// src/styles/playerProgressStyles.js
import { styled } from 'baseui';

export const PlayerProgressGrid = styled('div', ({ $theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: $theme.sizing.scale600,
}));

export const PlayerProgressItem = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.sizing.scale200,
}));

export const PlayerProgressLabel = styled('label', ({ $theme }) => ({
  fontWeight: 'bold',
  fontSize: $theme.typography.LabelMedium.fontSize,
  color: $theme.colors.contentPrimary,
}));

export const PlayerProgressInputGroup = styled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale300,
}));

export const PlayerProgressValueDisplay = styled('div', ({ $theme }) => ({
  fontSize: $theme.typography.font450.fontSize,
  fontWeight: 'bold',
  color: $theme.colors.contentPrimary,
  marginTop: $theme.sizing.scale100,
}));